import { AssemblyFilter, getAssemblies } from '@/assembly/api/get-assemblies';
import { useSuspenseQuery } from '@tanstack/react-query';

export const assembliesQueryKey = ['assemblies'];

interface UseAssembliesProps {
  filter?: AssemblyFilter;
}

export function useAssemblies({ filter }: UseAssembliesProps = {}) {
  const query = useSuspenseQuery({
    queryKey: [...assembliesQueryKey, ...(filter ? [filter] : [])],
    queryFn: () => getAssemblies(filter),
  });

  return {
    assemblies: query.data.data.results,
    resultCount: query.data.data.totalCount,
  };
}
